import React, {Component} from 'react';
import {connect} from 'react-redux';
import {sumBy} from 'lodash';
import {Card, Table, Loader} from 'semantic-ui-react';
import {getNumericValue} from '../../../common/util/fieldsValidation';
import {Actions} from '../../../common/actions';

const valueIfNull = '0';

class DataTable extends Component {
  componentDidMount() {
    const {filters} = this.props;
    this.props.fetchWalkIn(filters);
  }

  renderLoaderOrData = () => {
    const {loading} = this.props;

    if (loading) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }
    return this.renderTableInformation();
  }

  renderTableInformation = () => {
    const {walkIn, filters} = this.props;

    if (!walkIn.length) {
      return (
        <Table.Row textAlign='center'>
          <Table.Cell colSpan={4}>No hay datos</Table.Cell>
        </Table.Row>
      );
    }

    return walkIn.map((record, index) => {
      const title =
        filters && filters.clientId && filters.clientId !== 'ALL' ?
          record.agency :
          record.dealer;

      return (
        <Table.Row textAlign='center' key={index}>
          <Table.Cell collapsing className='lightgray-bg'>
            {title}
          </Table.Cell>
          <Table.Cell>{record.sales || valueIfNull}</Table.Cell>
          <Table.Cell>
            {getNumericValue(record.traffic, 0) || valueIfNull}
          </Table.Cell>
          <Table.Cell>{getNumericValue(record.percentage, 2)}%</Table.Cell>
        </Table.Row>
      );
    });
  }

  renderTotals = () => {
    const {loading, walkIn} = this.props;

    if (loading || !walkIn.length) {
      return null;
    }

    const totalSales = sumBy(walkIn, 'sales');
    const totalTraffic = sumBy(walkIn, 'traffic');

    return (
      <Table.Footer>
        <Table.Row textAlign='center'>
          <Table.HeaderCell className='lightgray-bg'>Total</Table.HeaderCell>
          <Table.HeaderCell className='lightgray-bg'>
            {totalSales || valueIfNull}
          </Table.HeaderCell>
          <Table.HeaderCell className='lightgray-bg'>
            {getNumericValue(totalTraffic, 0)}
          </Table.HeaderCell>
          <Table.HeaderCell className='lightgray-bg'>
            {totalTraffic ?
              `${getNumericValue((totalSales / totalTraffic) * 100, 2)}%` :
              `${valueIfNull}%`}
          </Table.HeaderCell>
        </Table.Row>
      </Table.Footer>
    );
  }

  render() {
    const {filters} = this.props;
    const title =
      filters && filters.clientId && filters.clientId !== 'ALL' ?
        'Agencias' :
        'Concesionarios';

    return (
      <Card raised fluid>
        <div className='title-bar'>
          <div className='title'>
            <h2>Tasa de cierre neta</h2>
          </div>
        </div>

        <Table className='gray-table'>
          <Table.Header>
            <Table.Row textAlign='center'>
              <Table.HeaderCell className='lightgray-bg'>
                {title}
              </Table.HeaderCell>
              <Table.HeaderCell className='lightgray-bg'>
                Ventas
              </Table.HeaderCell>
              <Table.HeaderCell className='lightgray-bg'>
                Walk Ins
              </Table.HeaderCell>
              <Table.HeaderCell className='lightgray-bg'>
                Tasa de cierre neta
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>{this.renderLoaderOrData()}</Table.Body>

          {this.renderTotals()}
        </Table>
      </Card>
    );
  }
}

const {
  fetchWalkIn,
} = Actions;

const mapStateToProps = (state) => {
  return {
    'loading': state.dailyVehiclesSalesAndStock.loadingWalkIn,
    'walkIn': state.dailyVehiclesSalesAndStock.walkIn,
  };
};

export default connect(mapStateToProps, {
  fetchWalkIn,
})(DataTable);
